// extracted by mini-css-extract-plugin
module.exports = {"actionsWrapper":"styles_actionsWrapper__DJL2i","title":"styles_title__LbEMP","phoneButton":"styles_phoneButton__sUurc"};
module.exports.__checksum = "cc5fe40b14e2"